import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4f85adf2 from 'nuxt_plugin_plugin_4f85adf2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_715c4b33 from 'nuxt_plugin_pluginutils_715c4b33' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_4176d7be from 'nuxt_plugin_pluginrouting_4176d7be' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_4e1d471e from 'nuxt_plugin_pluginmain_4e1d471e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_ba5097f0 from 'nuxt_plugin_axios_ba5097f0' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_svgicon_16778036 from 'nuxt_plugin_svgicon_16778036' // Source: ../plugins/svg-icon (mode: 'all')
import nuxt_plugin_route_231494d5 from 'nuxt_plugin_route_231494d5' // Source: ../plugins/route (mode: 'all')
import nuxt_plugin_included_77048d72 from 'nuxt_plugin_included_77048d72' // Source: ../plugins/included.js (mode: 'all')
import nuxt_plugin_antdui_2b2dca90 from 'nuxt_plugin_antdui_2b2dca90' // Source: ../plugins/antd-ui (mode: 'all')
import nuxt_plugin_gsap_926babe2 from 'nuxt_plugin_gsap_926babe2' // Source: ../plugins/gsap (mode: 'client')
import nuxt_plugin_videoplayer_cfd5b7a0 from 'nuxt_plugin_videoplayer_cfd5b7a0' // Source: ../plugins/video-player.js (mode: 'client')
import nuxt_plugin_move_b06bdfdc from 'nuxt_plugin_move_b06bdfdc' // Source: ../plugins/move.js (mode: 'client')
import nuxt_plugin_swiper_076f49ea from 'nuxt_plugin_swiper_076f49ea' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_aos_2279b4c6 from 'nuxt_plugin_aos_2279b4c6' // Source: ../plugins/aos.js (mode: 'client')
import nuxt_plugin_cropper_c8e4c7ce from 'nuxt_plugin_cropper_c8e4c7ce' // Source: ../plugins/cropper (mode: 'client')
import nuxt_plugin_vueswiper_72783184 from 'nuxt_plugin_vueswiper_72783184' // Source: ../plugins/vue-swiper.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"星游游戏平台_星耀天下_游戏人间_找好游戏上星游","htmlAttrs":{"lang":"zh"},"meta":[{"charset":"utf-8"},{"name":"keywords","content":"星游游戏,星渺游戏,调皮小动物,美杜莎传奇,血饮龙纹,烽火龙城,钢铁荣耀,据点守卫,钓鱼大冒险"},{"name":"description","content":"星游游戏平台，做专业的手机游戏发行平台！调皮小动物、烽火龙城、美杜莎传奇、血饮龙纹、钢铁荣耀，据点守卫，钓鱼大冒险等多款精品游戏，献给热爱游戏的你。星游游戏，与您分享简单的快乐！"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"noscript":[{"innerHTML":"This website requires JavaScript."}],"script":[{"src":"\u002Fjs\u002Fjquery-1.8.2.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fjs\u002Fmodernizr.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fjs\u002Fcute\u002Fcute.slider.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fjs\u002Fcute\u002Fcute.transitions.all.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fjs\u002Frespond.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fscript\u002Fskroller.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Fjs\u002Fmaster\u002Fmasterslider.js","type":"text\u002Fjavascript","charset":"utf-8"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4f85adf2 === 'function') {
    await nuxt_plugin_plugin_4f85adf2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_715c4b33 === 'function') {
    await nuxt_plugin_pluginutils_715c4b33(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_4176d7be === 'function') {
    await nuxt_plugin_pluginrouting_4176d7be(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_4e1d471e === 'function') {
    await nuxt_plugin_pluginmain_4e1d471e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ba5097f0 === 'function') {
    await nuxt_plugin_axios_ba5097f0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (typeof nuxt_plugin_svgicon_16778036 === 'function') {
    await nuxt_plugin_svgicon_16778036(app.context, inject)
  }

  if (typeof nuxt_plugin_route_231494d5 === 'function') {
    await nuxt_plugin_route_231494d5(app.context, inject)
  }

  if (typeof nuxt_plugin_included_77048d72 === 'function') {
    await nuxt_plugin_included_77048d72(app.context, inject)
  }

  if (typeof nuxt_plugin_antdui_2b2dca90 === 'function') {
    await nuxt_plugin_antdui_2b2dca90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gsap_926babe2 === 'function') {
    await nuxt_plugin_gsap_926babe2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videoplayer_cfd5b7a0 === 'function') {
    await nuxt_plugin_videoplayer_cfd5b7a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_move_b06bdfdc === 'function') {
    await nuxt_plugin_move_b06bdfdc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_076f49ea === 'function') {
    await nuxt_plugin_swiper_076f49ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_2279b4c6 === 'function') {
    await nuxt_plugin_aos_2279b4c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cropper_c8e4c7ce === 'function') {
    await nuxt_plugin_cropper_c8e4c7ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueswiper_72783184 === 'function') {
    await nuxt_plugin_vueswiper_72783184(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
